<div [ngClass]="'image-background image-background-' + platformType">
  <div class="browse-title-container">
    <div
      [ngClass]="'image-text-container image-text-container-' + platformType"
    >
      <ion-text [ngClass]="'image-text image-text-' + platformType">
        {{ 'i18n.search.browsePage.guestTitleImage' | translate }}
      </ion-text>
      <ng-container *ngIf="platformType !== platformEnum.mobile">
        <ion-text [ngClass]="'image-subtext image-subtext-' + platformType">
          {{ 'i18n.search.browsePage.guestTitleImageSubtextLine1' | translate }}
        </ion-text>
        <ion-text [ngClass]="'image-subtext image-subtext-' + platformType">
          {{ 'i18n.search.browsePage.guestTitleImageSubtextLine2' | translate }}
        </ion-text>
      </ng-container>
      <ng-container *ngIf="platformType === platformEnum.mobile">
        <ion-text [ngClass]="'image-subtext image-subtext-' + platformType">
          {{ 'i18n.search.browsePage.guestTitleImageSubtextLine1' | translate }}
          {{ 'i18n.search.browsePage.guestTitleImageSubtextLine2' | translate }}
        </ion-text>
      </ng-container>
      <ion-button
        [ngClass]="
          'usf-outline-green-button become-customer-button-' + platformType
        "
        (click)="onBecomeACustomerClick()"
      >
        {{ 'i18n.common.becomeACustomer' | translate }}
      </ion-button>
    </div>
  </div>
</div>
